export default __webpack_public_path__ + "static/media/customVoucher.8c78e43b.svg";